import type { FunctionComponent } from "../common/types";
import { Link } from "@tanstack/react-router";
import "react-lazy-load-image-component/src/effects/blur.css";
import EmblaCarousel from "../components/ui/Carousel/EmblaCarouselHorizontal";
import type { ArticleListEndpoint, ArticleParameters } from "../api/api";
// eslint-disable-next-line no-duplicate-imports
import { getArticleList } from "../api/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import ArticleCardCarousel from "../components/shared/ArticleCardCarousel";
import { Skeleton } from "../components/ui/skeleton";
import TextFragment from "../components/ui/textFragment";
import { useOnlineStatusContext } from "../context/OnlineStatusContext";
// import { TilesDivisionIntoNewVisual } from "@/components/home/TilesDivisionInto3/TilesDivisionIntoNewVisual";
import { TilesDivisionInto4_NewVisual } from "@/components/home/TilesDivisionInto4/TilesDivisionInto4_NewVisual";

export const DOWNLOAD_VIDEO_FEATURE_FLAG = false;
export const FEATURE_FLAG_COVER_CARD_NEW_VISUAL = true;
export const ONE_SIGNAL_FEATURE_FLAG = false;

const PER_PAGE = 5;

const articleListParameters: ArticleParameters = {
	search: "",
} as ArticleParameters;
export const Home = (): FunctionComponent => {
	const { isOnline } = useOnlineStatusContext();
	const { data, isLoading, isError } = useInfiniteQuery<
		ArticleListEndpoint,
		AxiosError
	>({
		queryKey: ["articlesList", articleListParameters],
		queryFn: async () => {
			const result = await getArticleList(articleListParameters, 1, PER_PAGE);
			if (!result) throw new Error("Failed to fetch articles");
			return result;
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage) => {
			const { page, total } = lastPage;
			const totalPages = Math.ceil(total / PER_PAGE); // Update based on `per_page`
			return page < totalPages ? page + 1 : undefined;
		},
		enabled: isOnline,
	});

	const items = data?.pages?.flatMap((page) => page.posts) ?? [];

	const articleSlides = items
		.map((post) => <ArticleCardCarousel article={post} key={post.ID} />)
		.slice(0, 5);

	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto flex flex-col">
			<div className="flex justify-between items-center pb-3">
				<TextFragment as="h2" className="text-text1" variant="title">
					Aktualności
				</TextFragment>
				<Link
					className="text-xs font-bold text-link"
					search={{ search: "" }}
					to="/articles"
				>
					<TextFragment as="span" variant="link">
						ZOBACZ WSZYSTKO
					</TextFragment>
				</Link>
			</div>
			{articleSlides && (
				<EmblaCarousel
					options={{ align: "start", loop: true }}
					slides={articleSlides}
				/>
			)}
			{(isLoading || isError) && (
				<div className="h-[15rem] w-full flex flex-col justify-center">
					{isLoading && (
						<Skeleton className="h-[215px] w-full pb-5 rounded-xl" />
					)}
					{isError && <div>Nie można załadować najnowszych artykułów</div>}
				</div>
			)}
			{FEATURE_FLAG_COVER_CARD_NEW_VISUAL && (
				<TilesDivisionInto4_NewVisual />
			)}
		</main>
	);
};
